<template>
  <div id="app">
    <HomePage/>
  </div>
</template>

<script>
import HomePage from './pages/Home'

export default {
  name: 'App',
  components: {
    HomePage
  }
}
</script>